import * as React from 'react';

import Button from './index';

const NoStyleButton = React.forwardRef<Button, any>((props, ref) => {
  return <Button {...props} ref={ref} styles="noStyle" />;
});

export default NoStyleButton;
